function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.5,
  fill: "#FADBDB",
  stroke: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 19L19 9",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 19C18.5556 18.5556 12.1481 12.1481 9 9",
  stroke: "black"
});

const SvgFailure = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFailure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/failure.9e7a0c0d.svg";
export { ForwardRef as ReactComponent };